export const Dictionary = {
  // presentation
  __presentation_1:
    "Il sito per gli scrittori di libri fantasy, romanzi e racconti con trame più articolate.",
  __presentation_2:
    "Plotter Studio è una piattaforma creata in collaborazione con scrittori per gli scrittori.",
  __presentation_3: "Stesura di trama basata su eventi",
  __presentation_4: "Ordine temporale",
  __presentation_5:
    "Tieni in ordine tutti gli eventi salienti della tua trama posizionandoli su una linea temporale. Gli eventi possono essere classificati per tipologia, personaggi coinvolti, parole chiave e altro!",
  __presentation_6: "Controllo",
  __presentation_7:
    "Verifica la consistenza degli eventi inseriti, così da evitare buchi di trama o incongruenze. Plotter Studio eseguirà per te l'analisi di tutti gli eventi e troverà potenziali errori.",
  __presentation_8: "Lavoro di squadra",
  __presentation_9:
    "Plotter Studio consente agli utenti di invitare altri a collaborare su uno stesso libro, così da permettere efficacia professionale anche in ambiente lavorativo.",
  __presentation_10: "Interfaccia intuitiva",
  __presentation_11:
    "L'uso di Plotter Studio è stato ottimizzato per essere di facile utilizzo, così che tu possa concentrarti sul tuo libro senza dover pensare ad altro.",
  __presentation_12: "Hai delle domande?",
  __presentation_12_2:
    "Il team di Plotter Studio è a tua disposizione per rispondere a tutte le tue domande",
  __presentation_13: "Contattaci",
  __presentation_14: "Oppure, puoi creare un account gratuitamente ",
  __presentation_14_2:
    "Con la registrazione ottieni un mese gratuito di accesso all'account mini, per provare il sistema.",
  __presentation_15: "Qualità professionale",
  __presentation_16:
    "Plotter Studio è sviluppata e mantenuta da un gruppo con esperienza decennale nel mondo informatico, e garantiamo continue evoluzioni nel tempo.",
  __footer_about_us: "Chi siamo",
  __footer_our_mission: "La nostra missione",
  __footer_were_are_we_headed: "Dove siamo diretti?",
  __footer_privacy: "Privacy",
  __footer_term_of_use: "Termini del servizio",
  __footer_services: "I nostri servizi",
  __footer_serv_support: "Supporto agli scrittori",
  __footer_serv_teaching: "Insegnamento",
  __footer_serv_private_solutions: "Soluzioni private",
  __footer_contact_us: "Contattaci",
  __footer_social_media: "Social media",
  __footer_social_facebook: "Facebook",
  __footer_social_twitter: "Twitter",
  __app_for_writers_logo: "L'app per gli scrittori",
  __service_support_title: "Supporto Tecnico",
  __service_support_desc:
    "Hai riscontrato un problema? Descrivici l'accaduto e il nostro team tecnico ti risponderà prontamente.",
  __service_teaching_title: "Formazione & Teaching",
  __service_teaching_desc:
    "Vuoi imparare a sfruttare al meglio i nostri strumenti? Richiedi informazioni sui nostri corsi e webinar.",
  __service_private_title: "Soluzioni Private",
  __service_private_desc:
    "Hai bisogno di un'infrastruttura dedicata? Parliamo di come possiamo scalare il tuo business con soluzioni su misura.",
  __mission_title: "Diamo potere ai narratori di domani",
  __mission_subtitle:
    "Colmiamo il divario tra l'immaginazione pura e i capolavori strutturati.",
  __mission_p1_title: "Domare il Caos",
  __mission_p1_desc:
    "Aiutiamo gli scrittori a superare gli ostacoli della coerenza e dei buchi di trama. Unendo un'IA avanzata a strumenti professionali, trasformiamo il difficile compito della scrittura in un viaggio guidato.",
  __mission_p2_title: "Gestire la Complessità",
  __mission_p2_desc:
    "I grandi progetti possono spaventare. Offriamo un ambiente controllato dove mondi complessi, linee temporali intricate e profili profondi dei personaggi sono facili da gestire, lasciandoti libero di concentrarti sull'arte di scrivere.",
  __mission_founder_title: "Creato da uno scrittore, per gli scrittori",
  __mission_founder_desc:
    "Ho creato questa piattaforma perché ne avevo bisogno. Come autore che faticava a tracciare migliaia di eventi nella mia saga fantasy, volevo uno strumento che non si limitasse a salvare dati, ma che comprendesse la storia. Questo è lo spazio di lavoro che ho sempre sognato.",
};
